import React, {useContext, useEffect, useMemo, useRef} from 'react';
import classNames from 'classnames';
import useStreamActionsSingle from "../../hooks/useStreamActionsSingle";
import {priceFormat} from '../Product/ProductPrice';
import ProductPreview from '../Product/ProductPreview';
import ProductDetails from '../Product/ProductDetails';
import {TABS, TYPE_BUNDLE} from "../../contants/common";
import {SYSTEM_ID_CHANGE_BUNDLE, SYSTEM_ID_CHANGE_SINGLE, SYSTEM_ID_TOGGLE_INSPECT,} from '../../contants/presets';
import {checkIsBundle} from '../../helpers/index';
import IconButton from "../IconButton/IconButton";
import AppContext from '../../store';
import useScreenOrientationExtended from "../../hooks/useScreenOrientationExtended";
import useDeviceSizeDetect from "../../hooks/useDeviceSizeDetect";
import ScrollableArea from "../ScrollableArea/ScrollableArea";
import PropTypes from 'prop-types';
import './styles/ConfiguratorsPanel.scss';
import {redirect} from '../Buttons/ButtonShopRedirect';
import useWindowSize from "../../hooks/useWindowSize";

export const TYPE_CONFIGURATOR_BUTTON_DEFAULT = 'default';
export const TYPE_CONFIGURATOR_BUTTON_HUGE = 'huge';

const extendTabs = items => {
	return items.map(el => ({
		...el,
		title: checkIsBundle(el.name)
			? el.text
			: el.name
	}))
}

/* Should keep for a Mobile portrait mode. Uses 'react-items-carousel' */
// const ConfiguratorContentListWrapper = ({length = 0, children}) => {
// 	const [activeItemIndex, setActiveItemIndex] = useState(0);
// 	const {isPortrait} = useScreenOrientationExtended();
// 	const detectMobile = useDeviceSizeDetect();
// 	const size = useWindowSize(200);
//
// 	const isShowCarousel = useMemo(() => {
// 		return detectMobile.isMobile() && isPortrait
// 	}, [detectMobile, isPortrait]);
//
// 	const numberOfCards = useMemo(() => {
// 		return size.width ? Math.floor(size.width / 142) : 2
// 	}, [size]);
//
// 	const isStretched = useMemo(() => length < 3, [length,children])
//
// 	return (
// 		<>
// 			{
// 				<ConditionalWrapper
// 					children={children}
// 					condition={isShowCarousel}
// 					wrapper={child => {
// 						return <ItemsCarousel
// 							requestToChangeActive={setActiveItemIndex}
// 							activeItemIndex={activeItemIndex}
// 							numberOfCards={numberOfCards}
// 							gutter={5}
// 							firstAndLastGutter={true}
// 							alwaysShowChevron={true}
// 							outsideChevron={false}
// 							leftChevron={<span>&nbsp;</span>}
// 							rightChevron={<span>&nbsp;</span>}
// 							classes={{
// 								wrapper: 'carousel',
// 								leftChevronWrapper: 'arrow arrow--prev',
// 								rightChevronWrapper: 'arrow arrow--next',
// 							}}
// 						>
// 							{child}
// 						</ItemsCarousel>
// 						}
// 					}
//
// 					altWrapper={child => (
// 						<div className={classNames('configurator-panel-tabs-content-list', {
// 							'stretched': isStretched,
// 						})}
// 						>
// 							<ScrollableArea>
// 								{child}
// 							</ScrollableArea>
// 						</div>
// 					)}
// 				/>
// 			}
// 		</>
// 	)
// };

// const ProductDetailsWrapper = ({children}) => {
// 	const size = useWindowSize(300);
// 	const {
// 		isProductDetailsOpen,
// 	} = useContext(AppContext);
//
// 	return <ConditionalWrapper
// 		children={children}
// 		condition={isSmallDevice(size.width)}
// 		wrapper={child => (
// 			<Portal id={'ProductDetails'}>
// 				<CSSTransition
// 					in={isProductDetailsOpen}
// 					appear={true}
// 					classNames="fade"
// 					timeout={700}
// 				>
// 					{child}
// 				</CSSTransition>
// 			</Portal>
// 		)}
// 	>
// 	</ConditionalWrapper>
// }

export const TabsNavigation = ({className}) => {
	const {
		activeTabId,
		setActiveTabId,
	} = useContext(AppContext);
	return (
		<div className={classNames(['configurator-panel-tabs-links', className])}>
			{
				extendTabs(TABS).map((
					{
						iconData,
						name,
						title
					}, i) => {
					return <div
						key={i}
						onClick={() => setActiveTabId(name)}
						className={classNames("configurator-panel-tabs-links-item", {
							'configurator-panel-tabs-links-item--active': activeTabId === name,
						})}>
						<div className={classNames(["configurator-panel-tabs-links-item-img", name])}>
							<IconButton {...iconData} />
						</div>
						<p className="configurator-panel-tabs-links-item-title">{title}</p>
					</div>
				})
			}
		</div>
	)
}

export function ConfiguratorButton(props) {
	const {type = TYPE_CONFIGURATOR_BUTTON_DEFAULT, children, onClick, className = ''} = props;
	return <div
		onClick={onClick}
		className={classNames('configurator-panel-nextButton', [className, type])}
	>
		{children}
	</div>
}

export function ConfiguratorNextStepButton() {
	const {
		activeTabId,
		setActiveTabId,
		getRedirectLink,
		selectedOptions,
		activeBundleId,
	} = useContext(AppContext);
	
	const linkRedirect = useMemo(getRedirectLink, [
		getRedirectLink,
		selectedOptions,
		activeBundleId,
	]);
	
	const handleNextClick = () => {
		if (activeTabId !== TABS[TABS.length - 1]['name']) {
			const tab = TABS.findIndex(tab => tab.name === activeTabId);
			if (tab > -1) {
				setActiveTabId(TABS[tab + 1]['name']);
			}
		} else {
			redirect(linkRedirect);
		}
	}
	
	return (
		<div className="configurator-panel-nextBox">
			{
				TABS.length
				? <ConfiguratorButton
						className={'configurator-panel-nextBox-custom'}
						onClick={handleNextClick}
					>
						{
							activeTabId !== TABS[TABS.length - 1]['name']
								? 'Nächster Schritt'
								: 'Zu allen Editions'
						}
					</ConfiguratorButton>
					: ''
			}
		</div>
	)
}

export default function ConfiguratorsPanel() {
	const {
		bundles,
		options,
		products,
		selectedOptions,
		activeBundleId,
		activeTabId,
		toggleProductsDetails,
		setSelectedOptions,
		setActiveBundleId,
		setProductDetailsId,
		getBundleById,
		getAllSelections,
		productDetailsId,
		setStreamStore,
	} = useContext(AppContext);

	const emitter = useStreamActionsSingle();
	const {
		isPortrait,
		className: orientationClassName,
	} = useScreenOrientationExtended();
	const detectMobile = useDeviceSizeDetect();
	const listRef = useRef(null);
	const isBundle = useMemo(() => {
		return checkIsBundle(activeTabId)
	}, [
		checkIsBundle,
		activeTabId,
	]);
	
	const getPriceProps = item => {
		const {active, type, price} = item;
		const _isBundle = checkIsBundle(type);
		if (_isBundle) {
			return {
				beforePrice: 'ab ',
				priceProps: priceFormat(price),
			};
		} else if (active) {
			return {
				priceProps: priceFormat(price, 'zero'),
			}
		} else {
			/* Does not support multi selections */
			if(selectedOptions) {
				const activeItemId = selectedOptions[type];
				const activeItem = products.find(el => el.id === activeItemId);
				if(activeItem) {
					const diff = activeItem.price ? activeItem.price - price : 0;
					return {
						beforePrice: `${diff < 0 ? '+' : '-'} `,
						priceProps: priceFormat(diff, 'diff'),
					}
				}
			}
		}
	};

	const handleProductClick = product => {
		const {type, id, active} = product;
		if (type === TYPE_BUNDLE) {
			const bundle = getBundleById(id);
			setActiveBundleId(id);
			setSelectedOptions(bundle.options.base);
			if(id !== activeBundleId) {
				emitter.emit({
					id: SYSTEM_ID_CHANGE_BUNDLE,
					data: product,
				});
			}
		} else if (!active) {
			/* Does not support multi selections */
			setSelectedOptions({
				...selectedOptions,
				[type]: id,
			});
			emitter.emit({
				id: SYSTEM_ID_CHANGE_SINGLE,
				data: product,
			});
		}
	};

	const handleProductInfoClick = product => {
		if(productDetailsId === product.id) {
			toggleProductsDetails()
		} else {
			setProductDetailsId(product.id)
		}
		setStreamStore({
			[SYSTEM_ID_TOGGLE_INSPECT]: 1
		})
	};

	const isShowTabsNavigation = useMemo(() => {
		return detectMobile.isDesktop && !detectMobile.isMobile
	}, [isPortrait, detectMobile]);

	const currentCategory = useMemo(() => {
		return TABS.find(el => el.name === activeTabId)?.text;
	}, [activeTabId]);

	const filteredProducts = useMemo(()=>{
		if (!bundles.length || !options.length) return [];
		if(isBundle) {
			return products
				.filter(el => el.type === TYPE_BUNDLE)
				.map(el => ({
					...el,
					active: el.id === activeBundleId,
				}))
		} else {
			const selections = getAllSelections();
			const ids = Object.values(selectedOptions || {});

			return Object.values(selections || {})
				.map(el => {
					return products.find(sub => sub.id === el.id);
				})
				.filter(el => el.type === activeTabId)
				.map(el => ({
					...el,
					active: ids.some(id => id === el.id),
				}))
		}
	}, [
		bundles,
		options,
		activeTabId,
		selectedOptions,
		activeBundleId,
		getAllSelections,
	])
	return (
		<div className="configurator-panel-container">
			<div className="configurator-panel-tabs">
				{
					isShowTabsNavigation && <TabsNavigation className={orientationClassName}/>
				}
				{/* TABS CONTENT */}
				<div className="configurator-panel-tabs-content">
					<h4 className="configurator-panel-title">WÄHLE DEINE {currentCategory}</h4>
					
					<div
						ref={listRef}
						className={classNames('configurator-panel-tabs-content-list ', {
						'stretched': true,
					})}
					>

						<ScrollableArea>
							<>
								{
									filteredProducts?.map((item, i) => {
										const isBundle = checkIsBundle(item.type);
										const priceProps = isBundle ? getPriceProps(item) : {};
										return <div
											key={i}
											className="configurator-panel-tabs-content-item">
											<ProductPreview
												onClickProduct={() => handleProductClick(item)}
												onClickInfo={() => handleProductInfoClick(item)}
												type={item.type}
												titleShort={item.titleShort}
												imgSrc={item.src}
												isSelected={item.active}
												{...priceProps}
											/>
										</div>
									})
								}
							</>
						</ScrollableArea>

					</div>

					{
						((detectMobile.isMobile && isPortrait) || detectMobile.isDesktop)
						&& <ConfiguratorNextStepButton />
					}
					
				</div>
			</div>
			<ProductDetails />
		</div>
	)
}

TabsNavigation.propTypes = {
	className: PropTypes.string,
}

ConfiguratorButton.propTypes = {
	onClick: PropTypes.func,
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]).isRequired,
	className: PropTypes.string,
}

// ConfiguratorContentListWrapper.propTypes = {
// 	length: PropTypes.number,
// 	children: PropTypes.oneOfType([
// 		PropTypes.arrayOf(PropTypes.node),
// 		PropTypes.node
// 	]).isRequired,
// }
// ProductDetailsWrapper.prototype = {
// 	children: PropTypes.oneOfType([
// 		PropTypes.arrayOf(PropTypes.node),
// 		PropTypes.node
// 	]).isRequired,
// }
